import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useChat } from '../ChatContext';

/**
 * Presigned-ссылка живёт 30 минут. Если картинка не загрузилась (403 после
 * протухания) — перезапрашиваем сообщение через историю и подставляем свежий
 * url. Пользователю ошибку не показываем.
 */
const ChatImage = ({ message, onOpen }) => {
  const { t } = useTranslation();
  const { refetchMessage } = useChat();
  const [src, setSrc] = useState(message.attachment?.url || '');
  const retriedRef = useRef(false);

  useEffect(() => {
    setSrc(message.attachment?.url || '');
    retriedRef.current = false;
  }, [message.attachment?.url]);

  const handleError = async () => {
    if (retriedRef.current || message.id == null) return;
    retriedRef.current = true;
    const fresh = await refetchMessage(message.chatId, message.id);
    if (fresh?.attachment?.url) setSrc(fresh.attachment.url);
  };

  if (!src) return null;

  return (
    <button type="button" className="chat-image-btn" onClick={() => onOpen?.(src)}>
      <img
        className="chat-image"
        src={src}
        alt={message.attachment?.fileName || t('chat.message.image')}
        onError={handleError}
        loading="lazy"
      />
    </button>
  );
};

export default ChatImage;
